<template>
	<div class="modal" tabindex="-1" role="dialog" id="muven-report-file-generation-filter-modal">
		<div class="modal-dialog modal-lg" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">
						<span>Filtro para geração do relatório</span>
						<br>
						<small class="text-muted">{{report.name}}</small>
					</h5>
				</div>
				<div class="modal-body">
					<div class="row" v-show="report.hasDateFilter()">
						<div class="col-12 col-md-6 form-group">
							<label>Data inicial</label>
							<v-date-picker 
								:input-props="{'class': 'form-control'}" 
								popover-visibility="focus"
								v-model="reportGeneratorFilter.dateStart" />
						</div>

						<div class="col-12 col-md-6 form-group">
							<label>Data final</label>
							<v-date-picker 
								:input-props="{'class': 'form-control'}" 
								popover-visibility="focus"
								v-model="reportGeneratorFilter.dateEnd" />
						</div>
					</div>

					<div class="row" v-show="report.hasStoresFilter()">
						<div class="col-12 form-group">
							<label>Lojas</label>
							<multiselect
								v-model="reportGeneratorFilter.storeListWrapper"
								:options="storeList"
								:multiple="true"
								:show-labels="false"
								:allow-empty="true"
								placeholder=""
								label="name"
								track-by="id" />
						</div>
					</div>

					<div class="row" v-show="report.hasChannelsFilter()">
						<div class="col-12 form-group">
							<label>Canais</label>
							<multiselect
								v-model="reportGeneratorFilter.channelListWrapper"
								:options="channelList"
								:multiple="true"
								:show-labels="false"
								:allow-empty="true"
								placeholder=""
								label="name"
								track-by="id" />
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" 
						class="btn btn-primary" 
						@click="submitFilter(reportGeneratorFilter)"
						:disabled="loading">
						Gerar

						<fa icon="sync-alt" class="mr-1" spin v-show="loading"/>
					</button>

					<button type="button" 
						class="btn btn-outline-secondary" 
						@click="close()">Fechar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ChannelService from '../../channel/services/ChannelService';
import store from '../../store';
import ModalService from '../../utils/services/ModalService';
import { ReportGeneratorFilterModel } from '../models/ReportGeneratorFilterModel'
import { StoreModel } from '../../store/models/StoreModel';
import { ReportModel } from '../models/ReportModel';

const ID_MODAL_FILTER = '#muven-report-file-generation-filter-modal';

export default {
	name: 'ReportGeneratorFilterCmp',
	data() {
		return {
			loading: false,
			storeList: [],
			channelList: [],
			report: new ReportModel(),
			reportGeneratorFilter: new ReportGeneratorFilterModel(), 
		}
	},
	methods: {
		submitFilter(filterForm) {
			this.loading = true;
			this.$emit('submit', filterForm.normalize())
		},
		async show(report) {
			this.report = report;

			this.loading = false;

			try {
				if (!this.storeList.length) {
					this.storeList = StoreModel.getStoreListWithIdAndName(store.state.storeList)
				}

				if (!this.channelList.length) {
					this.channelList = await ChannelService.getChannels()
				}

				await ModalService.show(ID_MODAL_FILTER)
			} catch (err) {
				this.$floatingAlert.error({
					message: err.message,
				})
			}
		},
		async close() {
			await ModalService.hide(ID_MODAL_FILTER)
		},
	},
}
</script>